/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Col, Layout, Row, Skeleton, notification } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../axios_instance';
import { EmployeeSearchCriteriaList } from '../../../../utils/option-list';
import PaginationComponent from '../../../general/pagination';
import Search from '../../../general/search';
import AdvancedSearchComponent from '../../../general/search/advanced-search';
import EmployeeList from '../../../uicontainers/admin/employee-list';
import styles from './styles.module.scss';
// import { Search } from 'react-router-dom';

// const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const EmployeeListView: React.FC = (): JSX.Element => {
  const [employeeList, setEmployeeList] = useState<Array<any>>([]);
  const [page, setPage] = useState<number>(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [url, setUrl] = useState<string>(`/api/v1/admin/profiles/?`);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAdSearch, setShowAdSearch] = useState<boolean>(false);
  const [disabledSearch, setDisabledSearch] = useState<boolean>(false);
  const navigation = useNavigate();
  const location = useLocation();

  const openNotification = (
    notificationType: 'success' | 'info' | 'warning' | 'error'
  ) => {
    notification[notificationType]({
      message: 'An error occurred!List can not load right now!',
    });
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageNumber = parseInt(params.get('page-number') || '1', 10);
    setPage(pageNumber);
  }, [location.search]);

  useEffect(() => {
    setIsLoading(true);
    const params = new URLSearchParams(location.search);

    const pageNumber = parseInt(params.get('page-number') || '1', 10);
    axiosInstance
      .get(url + 'page-number=' + pageNumber)
      .then((response) => {
        setEmployeeList(response.data.items);
        setTotal(response.data['total_items']);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  useEffect(() => {
    setIsLoading(true);

    axiosInstance
      .get(
        url.charAt(url.length - 1) === '&' ? url.slice(0, url.length - 1) : url
      )
      .then((response) => {
        setEmployeeList(response.data.items);
        setTotal(response.data['total_items']);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [url]);
  useEffect(() => {
    setIsLoading(true);
    const params = new URLSearchParams(location.search);

    const pageNumber = parseInt(params.get('page-number') || '1', 10);
    axiosInstance
      .get(
        url +
          (url.charAt(url.length - 1) === '?'
            ? 'page-number='
            : '&page-number=') +
          pageNumber
      )
      .then((response) => {
        setEmployeeList(response.data.items);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [page]);

  const updateUrlWithPageNumber = (pageNumber: number) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page-number', pageNumber.toString());
    navigation({ search: searchParams.toString() });
  };

  //  useEffect(() => {
  //    setIsLoading(true);
  //    axiosInstance
  //      .get(url + 'page-number=' + page)
  //      .then((response) => {
  //        setEmployeeList(response.data.items);
  //        setTotal(response.data['total_items']);
  //      })
  //      .catch((error) => {
  //        openNotification('error');
  //      })
  //      .finally(() => {
  //        setIsLoading(false);
  //      });
  //  }, [page]);

  return (
    <>
      <h1 className={styles['page-title']}>Home</h1>
      <div
        style={{ position: 'fixed', top: '164px', width: '100%', zIndex: 2 }}
      >
        <Row align={'middle'}>
          <Col span={12}>
            <Search
              {...{ setUrl, setPage, disabledSearch }}
              baseUrl={`/api/v1/admin/profiles/`}
              searchCriteriaList={EmployeeSearchCriteriaList}
            />
          </Col>
          <Col span={4}>
            <Button
              style={{ width: '100%', height: 40, marginLeft: '12px' }}
              onClick={() => {
                setDisabledSearch(false);
                setShowAdSearch(!showAdSearch);
                if (showAdSearch) {
                  setUrl(`/api/v1/admin/profiles/`);
                }
              }}
            >
              {showAdSearch ? 'Hide Advanced Search' : 'Show Advanced Search'}
            </Button>
          </Col>
        </Row>

        <br />
        <div
          style={{
            margin: '10px 20px',
            width: '100%',
          }}
        >
          <Row gutter={[16, 0]}>
            {showAdSearch && (
              <Col span={19}>
                <AdvancedSearchComponent
                  {...{ setUrl, setPage, setDisabledSearch }}
                  baseUrl={`/api/v1/admin/profiles/`}
                  searchCriteriaList={EmployeeSearchCriteriaList}
                />
              </Col>
            )}
          </Row>
        </div>
      </div>

      {/* <EmployeeList employeeList={employeeList.slice((page-1)*pageSize,Math.min(employeeList.length, page*pageSize))}/> */}
      <div
        style={{
          height: '250px',
          width: '100%',
          position: 'fixed',
          top: 1,
          background: '#f9fafd',
          zIndex: 1,
          marginTop: '10px',
        }}
      ></div>
      {/* <div style={{marginTop:"216px"}}> */}
      {isLoading ? (
        <Layout className={styles.layout}>
          <Content className={styles.container}>
            <Skeleton active /> <Skeleton active /> <Skeleton active />
          </Content>
        </Layout>
      ) : (
        <EmployeeList employeeList={employeeList} />
      )}

      {/* </div> */}

      <div
        style={{
          marginLeft: 'auto',
          marginRight: '10px',
          marginTop: '10px',
          marginBottom: '20px',
          float: 'right',
        }}
      >
        <PaginationComponent
          pageNumber={page}
          total={total}
          setPageNumber={updateUrlWithPageNumber}
          pageSize={pageSize}
        />
      </div>
    </>
  );
};

export default EmployeeListView;
